import React, {useEffect, useState} from 'react';
import Card from "../../components/Card";
import axios from "axios";
import {toast} from "react-toastify";
import {ORDER_PAGES} from "../JobOrderPage";
import ArchiveJobOrderModal from "../../modals/ArchiveJobOrderModal";
import OrderDetails from "./components/OrderDetails";
import KanBan from "./components/OrderProducts/KanBan";
import PdfDownloadButton from "../../components/PdfDownloadButton";

const JobOrderShowPage = (props) => {
    const {
        jobId           = null,
        orderId         = null,
        parentId        = "",
        onChangePage    = (INDEX, order) => {}
    } = props;

    const [job, setJob]                                     = useState(null);
    const [order, setOrder]                                 = useState(null);
    const [archiveJobOrderModal, setArchiveJobOrderModal]   = useState(null);
    const [draggable, setDraggable]                         = useState(false);

    useEffect(() => {
        load();
    }, [jobId, orderId]);

    const load = () => {
        axios.get(route('web-api.job.order.config', {job: jobId, order_id: orderId}).toString())
            .then((response) => {
                if (!!response && !!response.data) {
                    if (!!response.data.job) {
                        setJob(response.data.job);
                    }

                    if (!!response.data.order) {
                        setOrder(response.data.order);
                        setDraggable(response.data.order.draggable)
                    }
                }
            })
            .catch((error) => {
                console.log(error);
                toast.error(<div>{"An error occurred"}</div>);
            });
    }

    const renderActions = () => {
        return (
            <div className="dropdown float-right">
                <button
                    className="btn btn-eh-lilac dropdown-toggle px-3"
                    type="button" id="dropdownMenuButton"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                >
                    Actions
                </button>

                <div className="dropdown-menu p-0" aria-labelledby="dropdownMenuButton">
                    {!!order && !!order.can.view === true &&
                        (order.production_start_at && order.production_due_at && order.user_id
                        ?
                        (
                            <PdfDownloadButton
                                label="Order Sheet"
                                href={route('job.order.export', {
                                    job:     jobId,
                                    order:   order.id
                                }).toString()}
                            />
                        )
                        :
                        (
                            <button className={"dropdown-item cursor-pointer"}
                            onClick={() => {
                                toast.error("Job must have a Start Date, Due Date and an Assigned User");
                            }}
                            >
                                <span>Order Sheet</span>
                            </button>
                        ))}
                    {!!order && !!order.can.update === true && (
                        <button className={"dropdown-item cursor-pointer"}
                                onClick={() => onChangePage(ORDER_PAGES.EDIT, order)}
                        >
                            <span>Edit Order</span>
                        </button>
                    )}
                    {!!order && !!order.can.delete === true && (
                        <button className={"dropdown-item cursor-pointer"}
                                onClick={() => setArchiveJobOrderModal(order)}
                        >
                            <span>Delete Order</span>
                        </button>
                    )}
                </div>
            </div>
        );
    }

    return (
        <React.Fragment>
            <Card
                title={`Order Details: ${orderId}`}
                classes={"border-0"}
                noMargin={true}
                controls={can('viewAny', 'quote') ? renderActions() : null}
            >
                <OrderDetails order={order} />
            </Card>
            <div className={"px-4"}>
                <Card title={"Products"} classes={"border-0"} noPadding={true}>
                    <KanBan
                        jobId={jobId}
                        orderId={orderId}
                        parentId={parentId}
                        draggable={draggable}
                        updateDetails={load}
                    />
                </Card>
            </div>
            <ArchiveJobOrderModal
                show={!!archiveJobOrderModal}
                jobId={jobId}
                orderId={!!archiveJobOrderModal ? archiveJobOrderModal.id : null}
                parentId={parentId}
                onCancel={() => setArchiveJobOrderModal(null)}
                onComplete={(order) => {
                    setArchiveJobOrderModal(null)
                    window.location.replace(route('job.quote.index', {
                        job: jobId,
                    }).toString());
                }}
            />
        </React.Fragment>
    );
}

export default JobOrderShowPage;
